import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AddressValidation } from 'uplisting-frontend/validations';

export default class AddressRepositoryService extends BaseRepositoryService<
  ModelRegistry['address']
> {
  recordName = 'address';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = AddressValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/address': AddressRepositoryService;
  }
}
